angular.module('uiManager', []);

// not part of angular but required to be included to prevent pull down refresh on page
(function(){
    $(document).on('ready', function(){
        $('body').on('touchstart', function (e) {
            if (e.originalEvent.touches.length != 1) { return; }
            lastTouchY = e.originalEvent.touches[0].clientY;
            preventPullToRefresh = window.pageYOffset == 0;
        });

        $('body').on('touchmove', function (e) {
            var touchY = e.originalEvent.touches[0].clientY;
            var touchYDelta = touchY - lastTouchY;
            lastTouchY = touchY;
            if (preventPullToRefresh) {
                // To suppress pull-to-refresh it is sufficient to preventDefault the first overscrolling touchmove.
                preventPullToRefresh = false;
                if (touchYDelta > 0) {
                    e.preventDefault();
                    return;
                }
            }
        });
    });
})();